<template>
  <div
    class="page_container goodsManageSet"
    v-loading="loading"
    element-loading-text="请稍后"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/serviceIndex' }"
          >客户服务管理</el-breadcrumb-item
        >
        <el-breadcrumb-item :to="{ path: '/resourceIndex/rServiceDetail' }"
          >客户详情</el-breadcrumb-item
        >
        <el-breadcrumb-item>销售代客下单（销售业务订单）</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!--  主要内容 start -->
    <div class="form_container">
      <h1>销售代客下单（销售业务订单）</h1>
      <div class="content_wrap flex-between">
        <div class="form_wrap">
          <div class="block">
            <p>
              客户名称：{{
                customerDetail.info_truename
                  ? customerDetail.info_truename
                  : customerDetail.ext_name
              }}
            </p>
            <p>企业名称：{{ customerDetail.other_companystr }}</p>
            <p>职务：{{ customerDetail.other_job }}</p>
            <p>联系方式：{{ customerDetail.info_mobile }}</p>
            <p>
              所在地区：<span v-if="customerDetail.other_provincename">{{
                customerDetail.other_provincename
              }}</span>
              <span v-if="customerDetail.other_cityname"
                >、{{ customerDetail.other_cityname }}</span
              >
              <span v-if="customerDetail.other_areaname"
                >、{{ customerDetail.other_areaname }}</span
              >
              <span v-if="customerDetail.other_address"
                >、{{ customerDetail.other_address }}</span
              >
            </p>
          </div>
          <!-- <div class="block">
            <p><span class="mark">*</span>收件人：</p>
            <div class="input_box">
              <el-input
                v-model="formData.truename"
                placeholder="请输入收件人姓名，30个字符内"
              ></el-input>
            </div>
            <p><span class="mark">*</span>收件人联系方式：</p>
            <div class="input_box">
              <el-input
                v-model="formData.cellphone"
                placeholder="请输入收件人联系电话，20个字符内"
              ></el-input>
            </div>
          </div> -->
          <div class="block">
            <p>物流配送信息：</p>
            <div v-if="formData.addr">
              <p>收件人：{{ formData.truename }}</p>
              <p>收件人联系方式：{{ formData.cellphone }}</p>
              <p>收件人地址：{{ formData.addr }}</p>
            </div>

            <div class="add_btn flex-rowc" @click="handleShowAddress" v-else>
              + 选择物流配送信息
            </div>
            <!-- <div class="select_box">
              <el-select
                v-model="provinceId"
                placeholder="选择省/直辖市"
                @change="handleChange($event, 'province')"
              >
                <el-option
                  v-for="item in provinceList"
                  :key="item.areaid"
                  :label="item.areaname"
                  :value="item.areaid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="cityId"
                placeholder="选择城市"
                @change="handleChange($event, 'city')"
              >
                <el-option
                  v-for="item in cityList"
                  :key="item.cityid"
                  :label="item.cityname"
                  :value="item.cityid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="select_box">
              <el-select
                v-model="areaId"
                placeholder="选择所在区域"
                @change="handleChange($event, 'area')"
              >
                <el-option
                  v-for="item in areaList"
                  :key="item.addrid"
                  :label="item.addrname"
                  :value="item.addrid"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input_box">
              <el-input
                v-model="addrText"
                placeholder="请填写详细地址，50个字符内"
                type="textarea"
              ></el-input>
            </div> -->
          </div>
          <div class="block">
            <p>
              订单价格核算：<span>¥ </span>
              <span v-if="formData.price">{{
                formData.price | formatPrice
              }}</span>
              <span v-else>0.00</span>
            </p>
          </div>
          <div class="block">
            <div class="price_box flex-rowl">
              实际订单价格：
              <div class="input_box">
                <el-input
                  v-model="priceReal"
                  placeholder="请输入本次商品销售洽谈达成的实际价格"
                  @input="handleBlurPrice"
                ></el-input>
              </div>
              <!-- {{ formData.price_original ? formData.price_original : "0.00" }} -->
            </div>
            <p>
              差额核算：<span>¥ </span>
              <span v-if="formData.diffrentprice">{{
                formData.diffrentprice | formatPrice
              }}</span>
              <span v-else>0.00</span>
            </p>
          </div>

          <div class="block">
            <p>订单支付信息：</p>
            <div class="radio_box" style="margin: 25px auto 15px">
              <el-radio-group v-model="formData.paymsg">
                <el-radio label="银行转账">银行转账</el-radio>
                <el-radio label="支付宝">支付宝</el-radio>
                <el-radio label="微信支付">微信支付</el-radio>
                <el-radio label="其他第三方支付">其他第三方支付</el-radio>
              </el-radio-group>
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.paymsg_truename"
                placeholder="银行账户名 or 支付宝ID or 微信ID or 其他第三方支付名称"
              />
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.paymsg_bank"
                placeholder="开户行信息（银行转账以外的支付类型，请勿填写此项）"
              />
            </div>
            <div class="input_box">
              <el-input
                v-model="formData.paymsg_account"
                placeholder="银行账号（银行转账以外的支付类型，请勿填写此项）"
              />
            </div>
          </div>
          <div class="block">
            <p>备注信息：</p>
            <div class="input_box">
              <el-input
                v-model="formData.saler_note"
                placeholder="如有需要，请填写备注说明，200个字符内"
                type="textarea"
              />
            </div>
          </div>
        </div>
        <div class="shop_wrap">
          <div class="shop_list_wrap" v-if="selectIndexArr.length > 0">
            <div
              class="shop_item"
              v-for="(item, index) in selectIndexArr"
              :key="index"
            >
              <div class="txt">商品名称：{{ item.commodityname }}</div>
              <div class="label">
                <p
                  v-for="(itemAttr, indexAttr) in item.attrItem"
                  :key="indexAttr"
                >
                  {{ itemAttr }}
                </p>
              </div>
              <div class="price_group">
                <p>商品数量：{{ item.num }}</p>
                <p>商品单价：￥{{ item.price | formatPrice }}</p>
                <p>商品总价：￥{{ item.price_total | formatPrice }}</p>
                <!-- <p>商品实价：￥{{ item.priceReal | formatPrice }}</p>
                <p>差额小计：￥{{ item.priceDiff | formatPrice }}</p> -->
              </div>
              <div
                class="operation_wrap flex-rowl"
                @click="handleSetShopAttr(item, index)"
              >
                <div class="operate_btn flex-rowc">
                  商品属性参数设置 <i class="iconfont icon-gengduo1"></i>
                </div>
                <div
                  class="operate_btn flex-rowc"
                  @click="handleRemoveShop(index)"
                >
                  移除此商品 <i class="iconfont icon-dangeyichuicon"></i>
                </div>
              </div>
            </div>
          </div>
          <el-empty description="暂无商品" v-else></el-empty>
          <div class="add_btn flex-rowc" @click="handleAddShop">
            <i class="iconfont icon-components"></i>
            添加商品
          </div>
        </div>
      </div>
    </div>
    <div class="form_footer flex-rowl">
      <div class="btn" @click="handleSubmit">确认</div>
      <div class="return_txt" @click="handleReturn">←返回</div>
    </div>
    <!--  主要内容 end -->

    <!-- 商品列表弹窗 start -->
    <div class="custom_dialog" v-show="isShowShop">
      <div class="custom_wrap">
        <div class="diaog_head">
          <div class="search_wrap flex-rowl">
            <div class="search_box flex-between">
              <el-input
                v-model="shopForm.keyword"
                placeholder="查找商品"
                @keyup.enter.native="handleSearch"
              ></el-input>
              <div class="search_btn flex-rowc" @click="handleSearch">
                <i class="iconfont icon-chazhaotubiao"></i>
              </div>
            </div>
            <div class="rest flex-rowc" @click="handleRest">
              重置搜索结果
              <i class="iconfont icon-shuaxin"></i>
            </div>
          </div>

          <div class="close_icon" @click="isShowShop = false">
            <i class="iconfont icon-guanbi"></i>
          </div>
        </div>
        <div
          class="diaog_body"
          v-loading="isLoading"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.2)"
          ref="container"
          @scroll="handleScroll"
        >
          <div class="shop_wrap">
            <div
              class="shop_item flex-rowl"
              v-for="item in shopList"
              :key="item.id"
              @click="handleSelectShop(item)"
            >
              <!-- <div class="radio" :class="{ active: item.id == selectShop.id }">
                <span class="iconfont icon-danxuanyixuan"></span>
              </div> -->
              <div class="shop_cont flex-rowl">
                <div class="shop_img">
                  <el-image
                    style="width: 80px; height: 80px"
                    fit="cover"
                    :src="item.img"
                  ></el-image>
                </div>
                <div class="shop_txt">
                  <h1>{{ item.commodityname }}</h1>
                </div>
              </div>
            </div>
          </div>
          <el-empty
            description="暂无商品"
            v-if="shopList.length == 0 && !isLoading"
          ></el-empty>
        </div>
        <div class="dialog_footer flex-rowl">
          <!-- <div class="btn" @click="handleQueryShop">确认</div> -->
          <div class="return_txt" @click="isShowShop = false">←返回</div>
        </div>
      </div>
    </div>
    <!-- 商品列表弹窗 end -->

    <!-- 商品属性弹窗 start -->
    <div class="custom_dialog custom_dialog_attr" v-show="isShowShopAttr">
      <div class="custom_wrap">
        <div class="diaog_head">
          <div class="close_icon" @click="isShowShopAttr = false">
            <i class="iconfont icon-guanbi"></i>
          </div>
        </div>
        <div class="diaog_body">
          <div
            class="shop_attr_column"
            v-for="(item, index) in shopAttr"
            :key="index"
          >
            <div class="title">{{ item.attrname }}</div>
            <div class="select_list flex-rowl">
              <div
                v-for="(itemChild, indexChild) in item.items"
                :key="indexChild"
                @click="handleSelectAttr(item, itemChild, index)"
                class="select_item flex-between"
                :class="
                  selectIndexObj['select' + itemChild.attrid] ==
                  item.attrname + '-' + itemChild.attrvalue
                    ? 'active'
                    : ''
                "
              >
                <span class="txt">{{ itemChild.attrvalue }}</span>
                <span
                  v-if="
                    selectIndexObj['select' + itemChild.attrid] ==
                    item.attrname + '-' + itemChild.attrvalue
                  "
                  class="iconfont icon-3tuihuanhuozhengcegouxuan"
                ></span>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog_footer">
          <div class="step_wrap flex-rowc">
            <el-input-number
              v-model="num"
              @change="handleChangeShopNum"
              :min="1"
            ></el-input-number>
          </div>
          <div class="price_group">
            <div class="price_item flex-between">
              <p>商品标价核算：</p>
              <p class="price">
                <span>¥</span> {{ selectIndexObj.price_total | formatPrice }}
              </p>
            </div>
            <!-- <div class="price_item flex-rowl">
              <p class="flex-rowl"><span class="red">*</span>商品实价：</p>
              <div class="input_box">
                <el-input
                  v-model="priceReal"
                  placeholder="请输入本次商品销售洽谈达成的实际价格"
                  @input="handleBlurPrice"
                  type="number"
                ></el-input>
              </div>
            </div>
            <div class="price_item flex-between">
              <p>差额核算：</p>
              <p class="price">
                <span>¥</span>
                <span
                  v-if="
                    selectIndexObj.priceDiff != '' && selectIndexObj.priceDiff
                  "
                  >{{ selectIndexObj.priceDiff | formatPrice }}</span
                >
                <span v-else>0.00</span>
              </p>
            </div> -->
          </div>
          <div class="flex-rowl">
            <div class="btn" @click="handleQueryShopAttr">确认</div>
            <div class="return_txt" @click="handleReturnShop">←返回</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 商品属性弹窗 end -->

    <!-- 配送地址 -->
    <div class="custom_dialog custom_dialog_address" v-show="isAddress">
      <div class="custom_wrap">
        <div class="diaog_head">
          <div class="close_icon" @click="isAddress = false">
            <i class="iconfont icon-guanbi"></i>
          </div>
        </div>
        <div
          class="diaog_body"
          v-loading="isLoadingAddress"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.2)"
        >
          <div class="address_list" v-if="addressList.length > 0">
            <div
              v-for="(item, index) in addressList"
              :key="index"
              @click="selectAddressId = item.id"
            >
              <div :key="index" class="address_item flex-rowl">
                <div class="radio">
                  <span
                    class="iconfont"
                    :class="
                      item.id == selectAddressId
                        ? 'icon-danxuanyixuan1'
                        : 'icon-quanxuan'
                    "
                  ></span>
                </div>
                <div class="address_content">
                  <p>姓名：{{ item.truename }}</p>
                  <p>手机号：{{ item.mobile }}</p>
                  <p>
                    物流类型：{{
                      item.runtype == 1
                        ? "私人"
                        : item.runtype == 2
                        ? "办公"
                        : ""
                    }}
                  </p>
                  <p>
                    所在地区：<span>{{ item.provincestr }}</span>
                    <span>{{ item.citystr }}</span>
                    <span>{{ item.areastr }}</span>
                    <span>{{ item.addr }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <el-empty description="暂无数据" v-else></el-empty>
        </div>
        <div class="dialog_footer flex-between">
          <div class="flex-rowl">
            <div class="btn" @click="handleQueryAddress">确认</div>
            <div class="return_txt" @click="isAddress = false">←返回</div>
          </div>
          <div class="link">
            <a href="javascript:;" @click="handleGo">前往添加物流信息→</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getProvince,
  getCity,
  getArea,
  getCommondity,
  getCommidityDetail,
  encryptstringview,
  getCustomerDetail,
  encryptstringadd,
} from "../../../api/api";
import {
  getShopHPfLogistics,
  getCustomAddressList,
} from "../../../api/company";
import { addXsOrder, getLogistics } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "rServiceAddOrder",
  data() {
    return {
      id: "",
      loading: false,
      customerDetail: "",
      formData: {
        qyid: "",
        openid: "",
        ticket: "",
        goods: "",
        price_original: 0,
        price: 0,
        sendtime: "",
        addr: "",
        msg: "",
        ordertype: 43, // 2 = 普通商品订单 // 41=分销订单 42=团购订单 43=销售业务订单 44=批发订单 45=门店线下零售订单 46=门店线上应用零售订单 47=门店店仓提货  52=混批订单
        boxlogid: "",
        runfee: 0,
        score: 0,
        days: "",
        truename: "",
        cellphone: "",
        logisticsdf: 2, // 物流是否到付 =1=到付 2=其它
        diffrentprice: "", // 订单差额
        paymsg: "", // 支付信息
        paymsg_truename: "", // 支付信息-账户名
        paymsg_bank: "", // 支付信息-开户行
        paymsg_account: "", // 支付信息-账号
        saler: "", // 销售人员关联
        saler_note: "", // 销售人员备注
        qw_appid: "",
        qw_job: "",
        qy_truename: '',
        qy_linktype: ''
      },
      provinceList: [],
      provinceId: "",
      provinceText: "",
      cityList: [],
      cityId: "",
      cityText: "",
      areaList: [],
      areaId: "",
      areaText: "",
      addrText: "",

      actualMoney: "", // 实际价格
      payType: "", // 选择支付方式

      // 商品
      isShowShop: false,
      shopForm: {
        Page: 1,
        PageSize: 10,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 1, // 1 上架 0 下架 2 全部 留空为上架
        qyid: this.$store.state.USERINFO.qy
          ? this.$store.state.USERINFO.qy.id
          : 0,
      },
      isLoading: true,
      shopList: [],
      shopTotal: 0, // 商品总数量
      selectShop: {}, // 选中商品
      shopDetail: {}, // 商品详情
      // 商品属性
      isShowShopAttr: false,
      shopAttr: [],
      selectIndexObj: {
        attrItem: [],
        arrItem: [],
        // priceReal: "",

        attr: [],
        // attr : v.commodityattr,
        commodityid: "",
        commoditylabel: "",
        // commoditylabel : v.commoditylabel,
        commodityname: "",
        num: 0,
        price: "", // 单价
        price_total: "", // 总价
        attrnumtype: "", // 属性价格变动类型： 不变、增加、减少
        attrnum: "", // 属性价格变动值
        codetype: "", // 优惠价类型 1-百分比、2-固定金额
        discount: "", // 优惠券值
      }, // 商品属性选中
      selectIndexArr: [], // 商品属性选中
      num: 1, // 数量
      priceReal: "", // 真实价格
      isSetAttr: false,
      setAttrIndex: "", // 设置属性的索引

      qyguid: "",
      logisticsMoney: 0, // 默认物流费用
      hpLogiMange: "", // 混批物流管理
      runfeeArr: [], // 多个商品的物流费用

      customerGuid: "", //
      isAddress: false, // 配送地址
      isLoadingAddress: false,
      addressList: [],
      selectAddressId: "",
    };
  },
  filters: {
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) return;
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID", "USERINFO"]),
  },
  created() {
    this.getProvince();
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyguid = USERINFO.qy.qyguid;
    this.getShopHPfLogistics();
    this.getLogistics();
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },

  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, customerGuid } = JSON.parse(res.jsondata);
        this.id = id;
        this.customerGuid = customerGuid;
        console.log(customerGuid, "--customerGuidcustomerGuid");
        this.getCustomerDetail();
      } else {
        this.$router.back();
      }
    },
    // 获取默认物流
    getLogistics() {
      getLogistics({ qyguid: this.qyguid }).then((res) => {
        this.logisticsMoney = res.paydemo ? res.paydemo : 0;
        this.formData.runfee = res.paydemo ? res.paydemo : 0;
      });
    },
    // 获取物流混批数据
    getShopHPfLogistics() {
      let params = {
        qyguid: this.qyguid,
        pageindex: 1,
        pagesize: 10,
      };
      getShopHPfLogistics(params).then((res) => {
        this.hpLogiMange = res.list.length > 0 ? res.list[0] : "";
      });
    },
    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        this.customerDetail = res;
        this.formData.qw_appid = res.other_company;
        this.formData.qw_job = res.other_job;
        this.formData.qy_truename = res.info_truename;
        this.formData.qy_linktype = res.info_mobile;
      });
    },
    // 获取客户详情
    getCustomAddressList() {
      this.isLoadingAddress = true;
      getCustomAddressList({ guid: this.customerGuid }).then((res) => {
        let newRes = res.list.filter((v) => v.isuse == 1);
        this.addressList = newRes;
        this.isLoadingAddress = false;
      });
    },
    // 显示物流弹窗
    handleShowAddress() {
      this.isAddress = true;
      this.getCustomAddressList();
    },
    // 物流单选
    handleQueryAddress() {
      let { selectAddressId, addressList } = this;
      addressList.forEach((v) => {
        if (v.id == selectAddressId) {
          this.provinceText = v.provincestr;
          this.formData.truename = v.truename;
          this.formData.cellphone = v.mobile;
          this.formData.addr = v.provincestr + v.citystr + v.areastr + v.addr;
        }
      });
      this.editLogistics(this.hpLogiMange);
      this.isAddress = false;
    },

    // 搜索商品
    handleSearch() {
      this.shopForm.Page = 1;
      this.shopList = [];
      this.loadMore();
    },
    // 重置搜索结果
    handleRest() {
      this.shopForm.Page = 1;
      this.shopForm.keyword = "";
      this.shopList = [];
      this.loadMore();
    },
    async loadMore() {
      this.isLoading = true;
      try {
        const res = await getCommondity(this.shopForm);
        if (res.list.length > 0) {
          this.shopList = [...this.shopList, ...res.list];
          this.shopTotal = res.total;
          this.shopForm.Page += 1;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleScroll() {
      const container = this.$refs.container;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        this.loadMore();
      }
    },

    // 商品详情
    getCommidityDetail() {
      getCommidityDetail({ id: this.selectShop.id }).then((res) => {
        this.shopDetail = res;
        this.shopAttr = res.attr;
        this.isShowShop = false;
        this.isShowShopAttr = true;
        this.defaultSelectAttr(res.attr, res);
      });
    },

    // 添加商品
    handleAddShop() {
      this.selectShop = {};
      this.shopDetail = {};
      this.loadMore();
      this.isShowShop = true;
    },
    // 移除商品
    handleRemoveShop(index) {
      this.selectIndexArr.splice(index, 1);
    },
    // 设置商品属性
    handleSetShopAttr(item, index) {
      this.isShowShopAttr = true;
      this.isSetAttr = true;
      this.selectIndexObj = item;
      this.num = item.num;
      this.setAttrIndex = index;
    },

    // 选中商品
    handleSelectShop(item) {
      this.selectShop = item;
      this.getCommidityDetail();
    },
    // 确认商品
    // handleQueryShop() {
    //   if (!this.selectShop.id) {
    //     this.$message.warning("请选择商品！");
    //     return;
    //   }
    //   this.getCommidityDetail();
    // },

    // 操作商品的属性
    handleSelectAttr(item, itemChild, index) {
      this.selectIndexObj.arrItem[index] = itemChild;
      this.selectIndexObj.attrItem[index] =
        item.attrname + ":" + itemChild.attrvalue;
      this.selectIndexObj[`num`] = this.num;
      this.$set(
        this.selectIndexObj,
        `select${item.attrid}`,
        item.attrname + "-" + itemChild.attrvalue
      );
      this.getComputePrice(this.selectIndexObj, this.shopDetail);
    },
    // 默认选中属性
    defaultSelectAttr(arr, detail) {
      let arrItem = [];
      let attrItem = [];
      // arr.forEach((v) => {
      //   this.$set(
      //     this.selectIndexObj,
      //     `select${v.attrid}`,
      //     v.attrname + "-" + v.items[0].attrvalue
      //   );
      //   arrItem.push(v.items[0]);
      //   attrItem.push(v.attrname + ":" + v.items[0].attrvalue);
      // });
      this.selectIndexObj.commodityname = detail.commodityname;
      this.selectIndexObj.num = this.num;
      this.selectIndexObj.arrItem = arrItem;
      this.selectIndexObj.attrItem = attrItem;
      this.selectIndexObj.attr = attrItem;
      this.getComputePrice(this.selectIndexObj, detail);
    },
    // 计算价格
    getComputePrice(attrSelectObj, detail) {
      // 不同规格价格
      let attrPrice = 0;
      attrSelectObj.arrItem.forEach((v) => {
        // numtype-增加  numtype-减少
        if (v.numtype == "减少") {
          attrPrice = calculator(attrPrice).subtract(v.num).toNumber();
          // attrPrice += -(v.num)
        } else {
          attrPrice = calculator(attrPrice).add(v.num).toNumber();
          // attrPrice += v.num
        }
      });
      this.selectIndexObj.price_total = calculator(
        calculator(detail.price).add(attrPrice)
      )
        .multiply(this.num)
        .toNumber(); // 标价
      // if (attrSelectObj.priceReal == "") {
      //   this.selectIndexObj.priceDiff = "";
      //   return;
      // }
      // // this.selectIndexObj.priceReal = 0; // 实际价格
      // this.selectIndexObj.priceDiff = calculator(this.selectIndexObj.price_total)
      //   .subtract(this.selectIndexObj.priceReal)
      //   .toNumber(); // 差价
    },

    // 价格输入失去焦点
    handleBlurPrice() {
      let { price } = this.formData;
      if (price === 0) {
        this.$message.warning("请添加商品");
        this.priceReal = "";
        return;
      }
      // 移除非数字字符
      if (this.priceReal == "") {
        this.formData.diffrentprice = "";
        this.priceReal = "";
        return;
      }
      let newPrice = this.priceReal.replace(/^(\d*(?:\.\d{0,2})?).*$/, '$1');
      // let newPrice = newPrice1.replace(/^(-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
      
      console.log(newPrice,'===--=');
      this.priceReal = newPrice
      this.formData.diffrentprice = calculator(price)
        .subtract(Number(newPrice))
        .toNumber();
    },

    // 操作商品数量
    handleChangeShopNum(e) {
      if (e == undefined) {
        this.$nextTick(() => {
          this.num = 1;
        });
        this.selectIndexObj.num = this.num;
        this.getComputePrice(this.selectIndexObj, this.shopDetail);
        return;
      }
      let reg = /^[0-9]+$/;
      if (!reg.test(this.num)) {
        // this.$message.warning("当前只能输入整数")
        this.$nextTick(() => {
          this.num = parseInt(this.num);
        });
      }
      this.selectIndexObj.num = this.num;
      this.getComputePrice(this.selectIndexObj, this.shopDetail);
    },
    // 返回商品
    handleReturnShop() {
      let { isSetAttr } = this;
      if (!isSetAttr) {
        this.isShowShop = true;
        this.isShowShopAttr = false;
      } else {
        this.isShowShopAttr = false;
      }
    },
    handleQueryShopAttr() {
      let { isSetAttr, setAttrIndex, selectIndexObj, shopDetail, num } = this;
      let newSelectIndexObj = JSON.parse(JSON.stringify(selectIndexObj));
      if (newSelectIndexObj.attr.length == 0) {
        this.$message.warning("请选择商品属性");
        return;
      }
      newSelectIndexObj.commodityname = shopDetail.commodityname;
      newSelectIndexObj.commodityid = shopDetail.id;
      newSelectIndexObj.price = shopDetail.price;
      newSelectIndexObj.num = num;
      // 商品属性的汇总 start
      let newAttrnum = 0;
      newSelectIndexObj.arrItem.forEach((v) => {
        if (v.numtype === "增加") {
          newAttrnum = calculator(newAttrnum).add(v.num).toNumber();
        } else if (v.numtype === "减少") {
          newAttrnum = calculator(newAttrnum).sub(v.num).toNumber();
        } else if (v.numtype === "不变") {
          newAttrnum = calculator(newAttrnum).add(v.num).toNumber();
        }
      });

      newSelectIndexObj.attrnumtype =
        newAttrnum < 0 ? "减少" : newAttrnum === 0 ? "不变" : "增加";
      newSelectIndexObj.attrnum =
        newAttrnum < 0 ? Math.abs(newAttrnum) : newAttrnum;
      console.log(selectIndexObj, newSelectIndexObj, "=====-------");
      // if (priceReal == "") {
      //   this.$message.warning("请输入商品实价！");
      //   return;
      // }
      if (!isSetAttr) {
        this.selectIndexArr.push(newSelectIndexObj);
      } else {
        this.selectIndexArr[setAttrIndex] = newSelectIndexObj;
        this.isSetAttr = false;
      }
      this.num = 1;
      this.isShowShopAttr = false;
      this.getComputePriceEnd();
      this.handleBlurPrice();
    },
    // 计算最终价格
    getComputePriceEnd() {
      let { selectIndexArr } = this;
      selectIndexArr.forEach((v) => {
        this.formData.price = calculator(this.formData.price)
          .add(v.price_total)
          .toNumber();
        this.formData.price_original = this.formData.price;
      });
    },

    // 获取城市
    getProvince() {
      getProvince().then((res) => {
        this.provinceList = res;
      });
    },
    // 获取城市
    getCity() {
      getCity(this.provinceId).then((res) => {
        this.cityList = res;
      });
    },
    // 获取区域
    getArea() {
      getArea(this.cityId).then((res) => {
        this.areaList = res;
      });
    },
    // 地址下拉选择框触发事件
    handleChange(e, type) {
      let { provinceList, cityList, areaList } = this;
      if (type == "province") {
        provinceList.forEach((v) => {
          if (v.areaid == e) {
            this.provinceText = v.areaname;
          }
        });
        this.provinceId = e;
        this.cityId = "";
        this.cityText = "";
        this.areaId = "";
        this.areaText = "";
        this.getCity();
        this.editLogistics(this.hpLogiMange);
      } else if (type == "city") {
        cityList.forEach((v) => {
          if (v.cityid == e) {
            this.cityText = v.cityname;
          }
        });
        this.cityId = e;
        this.areaId = "";
        this.areaText = "";
        this.getArea();
      } else if (type == "area") {
        areaList.forEach((v) => {
          if (v.addrid == e) {
            this.areaText = v.addrname;
          }
        });
        this.areaId = e;
      }
    },

    // 根据地址判断是否修改物流费用
    editLogistics(shopLog) {
      let { provinceText, logisticsMoney } = this;
      // let that = this;
      let shopOrder = "";
      /**
       * 目前物流参数有两大类：商家物流管理、商品物流管理
       * 1、商家物流管理-混批
       * 2、商品物流管理
       *    2-1、零售物流runmsg-单个商品、购物车商品
       *    2-3、批发物流runmsg2-单个商品的批发（不同属性）
       * **/
      /**
       * 1、统一收费标准runtype=1；无特殊订单规则orderrule=1；无特殊地区规则specialarea=1
       * 2、统一收费标准runtype=1；特殊订单规则-商品数量免物流费orderrule=2、goodsfullnum(商品数量)；无特殊地区规则specialarea=1
       * 3、统一收费标准runtype=1；特殊订单规则-商品数量免物流费orderrule=2、goodsfullnum(商品数量)，如果商品数量超出设定值则物流费用为0；特殊地区规则（物流费用增加）specialarea=2、specialprovincestr（地区名称，逗号分隔的字符串）
       * 4、免物流费用runtype=2；特殊订单规则设置、特殊地区规则设置将无效
       * 5、部分地区免物流费用runtype=3，provincestr（地区名称，逗号分隔的字符串）选中的成功物流费用为0；
       * 5-1、选中的城市，特殊订单规则设置、特殊地区规则设置将无效
       * 5-2、未选中的城市，无特殊订单规则orderrule=1；无特殊地区规则specialarea=1
       * 5-3、未选中的城市，特殊订单规则-商品数量免物流费orderrule=2、goodsfullnum(商品数量)；无特殊地区规则specialarea=1
       * 5-4、未选中的城市，特殊订单规则-商品数量免物流费orderrule=2、goodsfullnum(商品数量)；特殊地区规则（物流费用增加）specialarea=2、specialprovincestr（地区名称，逗号分隔的字符串）
       * **/
      // 商品的物流规则
      // let shopLog = ''
      // if (this.data.type == 1) {
      //   shopLog = shopOrder.shopItem[0].detail.runmsg ? shopOrder.shopItem[0].detail.runmsg : ''
      // } else if (this.data.type == 2 && shopOrder.shopItem[0].detail.runmsg2) {
      //   try {
      //     shopLog = JSON.parse(shopOrder.shopItem[0].detail.runmsg2);
      //   } catch (error) {
      //     shopLog = shopOrder.shopItem[0].detail.runmsg2
      //   }
      // }
      let newRunfeeArr = [];
      if (!shopLog || !shopLog.runtype) {
        newRunfeeArr.push(logisticsMoney);
        // that.runfeeArr = newRunfeeArr;
        return;
      }
      // 统一标准收取
      if (shopLog.runtype == 1) {
        if (shopLog.orderrule == 1 && shopLog.specialarea == 1) {
          newRunfeeArr.push(logisticsMoney);
          // that.runfeeArr = newRunfeeArr;
        }
        if (shopLog.orderrule == 1 && shopLog.specialarea == 2) {
          if (
            shopLog.specialprovincestr.split(",").indexOf(provinceText) !== -1
          ) {
            // 物流价 = 物流价-logisticsMoney + 物流价-logisticsMoney * 增加费用的百分比-shopLog.pernum
            let percent = calculator(shopLog.pernum).divide(100).toNumber();
            let newLogistics = calculator(logisticsMoney)
              .add(calculator(logisticsMoney).multiply(percent))
              .toNumber();
            newRunfeeArr.push(newLogistics);
            // that.runfeeArr = ;
          } else {
            newRunfeeArr.push(logisticsMoney);
            // that.runfeeArr = ;
          }
        }
        if (shopLog.orderrule == 2 && shopLog.specialarea == 1) {
          if (shopLog.goodsfullnum <= shopOrder.checkLen) {
            newRunfeeArr.push(0);
            // that.runfeeArr = ;
          } else {
            newRunfeeArr.push(logisticsMoney);
            // that.runfeeArr = ;
          }
        }
        if (shopLog.orderrule == 2 && shopLog.specialarea == 2) {
          if (shopLog.goodsfullnum <= shopOrder.checkLen) {
            newRunfeeArr.push(0);
            // that.runfeeArr = ;
            return;
          }
          if (
            shopLog.specialprovincestr.split(",").indexOf(provinceText) !== -1
          ) {
            // 物流价 = 物流价-slogisticsMoney + 物流价-logisticsMoney * 增加费用的百分比-shopLog.pernum
            let percent = calculator(shopLog.pernum).divide(100).toNumber();
            let newLogistics = calculator(logisticsMoney)
              .add(calculator(logisticsMoney).multiply(percent))
              .toNumber();
            newRunfeeArr.push(newLogistics);
            // that.runfeeArr = ;
          } else {
            newRunfeeArr.push(logisticsMoney);
            // that.runfeeArr = ;
          }
        }
      }
      // 免物流费用  --  到付
      if (shopLog.runtype == 2 || shopLog.runtype == 4) {
        newRunfeeArr.push(0);
        if (shopLog.runtype == 4) {
          this.formData.logisticsdf = 1;
        }
        // this.runfeeArr = newRunfeeArr;
      }
      // 部分地区免费物流
      if (shopLog.runtype == 3) {
        if (shopLog.provincestr.split(",").indexOf(provinceText) !== -1) {
          newRunfeeArr.push(0);
          // that.runfeeArr = ;
        } else {
          if (shopLog.orderrule == 1 && shopLog.specialarea == 1) {
            newRunfeeArr.push(logisticsMoney);
            // that.runfeeArr = ;
          }
          if (shopLog.orderrule == 1 && shopLog.specialarea == 2) {
            if (
              shopLog.specialprovincestr.split(",").indexOf(provinceText) !== -1
            ) {
              // 物流价 = 物流价-logisticsMoney + 物流价-logisticsMoney * 增加费用的百分比-shopLog.pernum
              let percent = calculator(shopLog.pernum).divide(100).toNumber();
              let newLogistics = calculator(logisticsMoney)
                .add(calculator(logisticsMoney).multiply(percent))
                .toNumber();
              newRunfeeArr.push(newLogistics);
              // that.runfeeArr = ;
            } else {
              newRunfeeArr.push(logisticsMoney);
              // that.runfeeArr = ;
            }
          }
          if (shopLog.orderrule == 2 && shopLog.specialarea == 1) {
            if (shopLog.goodsfullnum <= shopOrder.checkLen) {
              newRunfeeArr.push(0);
              // that.runfeeArr = ;
            } else {
              newRunfeeArr.push(logisticsMoney);
              // that.runfeeArr = ;
            }
          }
          if (shopLog.orderrule == 2 && shopLog.specialarea == 2) {
            if (shopLog.goodsfullnum <= shopOrder.checkLen) {
              newRunfeeArr.push(0);
              // that.runfeeArr = ;
              return;
            }
            if (
              shopLog.specialprovincestr.split(",").indexOf(provinceText) !== -1
            ) {
              // 物流价 = 物流价-logisticsMoney + 物流价-logisticsMoney * 增加费用的百分比-shopLog.pernum
              let percent = calculator(shopLog.pernum).divide(100).toNumber();
              let newLogistics = calculator(logisticsMoney)
                .add(calculator(logisticsMoney).multiply(percent))
                .toNumber();
              newRunfeeArr.push(newLogistics);
              // that.runfeeArr = ;
            } else {
              newRunfeeArr.push(logisticsMoney);
              // that.runfeeArr = ;
            }
          }
        }
      }
      this.runfeeArr = newRunfeeArr;
    },

    // 提交数据
    handleSubmit() {
      let { formData, selectIndexArr, USERINFO, OPENID, priceReal, runfeeArr } =
        this;
      const maxRunfee = Math.max(...runfeeArr);
      this.formData.runfee = maxRunfee;
      console.log(formData, "==-==formData");
      if (formData.truename == "") {
        this.$message.warning("请输入收件人姓名！");
        return;
      }
      if (formData.cellphone == "") {
        this.$message.warning("请输入收件人联系方式！");
        return;
      }
      if (formData.addr == "") {
        this.$message.warning("请输入收件人配送地址！");
        return;
      }
      if (selectIndexArr.length == 0) {
        this.$message.warning("请选择商品！");
        return;
      }
      if (priceReal == "") {
        this.$message.warning("请填写实际订单价格！");
        return;
      }
      if (formData.paymsg == "") {
        this.$message.warning("请选择支付信息");
        return;
      }
      if (formData.paymsg_truename == "") {
        this.$message.warning("请输入支付信息-账户名");
        return;
      }
      if (formData.paymsg_bank == "") {
        this.$message.warning("请输入支付信息-开户行");
        return;
      }
      if (formData.paymsg_account == "") {
        this.$message.warning("请输入支付信息-账号");
        return;
      }

      // this.formData.addr = provinceText + cityText + areaText + addrText;
      this.formData.openid = OPENID;
      this.formData.qyid = USERINFO.qy.id;
      this.formData.saler = USERINFO.truename;
      this.formData.price = priceReal;
      let newGoods = selectIndexArr.map(
        ({
          attr,
          commodityid,
          commoditylabel,
          commodityname,
          num,
          price,
          price_total,
          attrnumtype,
          attrnum,
          codetype,
          discount,
        }) => ({
          attr,
          commodityid,
          commoditylabel,
          commodityname,
          num,
          price,
          price_total,
          attrnumtype,
          attrnum,
          codetype,
          discount,
        })
      );
      this.formData.goods = JSON.stringify(newGoods);
      this.loading = true;
      addXsOrder(this.formData).then((res) => {
        if (res.result) {
          // let message = this.$message.success(res.message);
          // message.close();
          setTimeout(() => {
            this.loading = false;
            this.$router.back();
          }, 500);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.back();
    },

    handleGo() {
      this.encryptstringadd("addressList", {
        id: this.id,
        customerGuid: this.customerDetail.guid,
      });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  .form_container {
    .content_wrap {
      .form_wrap {
        margin-right: 100px;
      }
      .price_box {
        font-size: 16px;
        color: #6e6e6e;
        margin-bottom: 10px;
        .input_box {
          flex: 1;
        }
      }
      .shop_wrap {
        flex: 1;
        font-size: 16px;
        .shop_list_wrap {
          .shop_item {
            margin-bottom: 20px;
          }
          .txt {
          }
          .label {
            color: #969696;
            margin: 10px 0 20px;
          }
          .price_group {
            font-size: 14px;
            p {
              margin-bottom: 5px;
            }
          }
          .operation_wrap {
            margin-top: 10px;
            .operate_btn {
              border-radius: 20px;
              border: 1px solid #dcdfe6;
              font-size: 14px;
              margin-right: 10px;
              padding: 5px 10px;
              cursor: pointer;
              .icon-gengduo1 {
                font-size: 14px;
                margin-left: 10px;
              }
              .icon-dangeyichuicon {
                font-size: 12px;
                margin-left: 10px;
              }
            }
          }
        }

        /deep/ .el-empty {
          padding: 0;
        }
        /deep/ .el-empty__image {
          width: 100px;
        }
      }
      .add_btn {
        height: 50px;
        border: 1px solid #dcdfe6;
        // background: #fff;
        cursor: pointer;
        margin-top: 30px;
        .icon-components {
          margin-right: 10px;
          font-size: 18px;
          color: #515151;
        }
      }
    }
  }
  .custom_dialog {
    .search_wrap {
      .search_box {
        flex-shrink: 0;
        width: 60%;
      }
      .rest {
        font-size: 14px;
        color: #444;
        height: 35px;
        border-radius: 18px;
        border: 1px solid #d8d8d8;
        padding: 0 14px 0 28px;
        margin-left: 19px;
        cursor: pointer;
        .iconfont {
          margin-left: 10px;
        }
      }
    }
    .shop_wrap {
      .shop_item {
        cursor: pointer;
        margin-bottom: 15px;
        .radio {
          margin-right: 10px;
          color: #c8c8c8;
          &.active {
            color: #515151;
          }
        }
        .shop_cont {
          // align-items: flex-start;
          h1 {
            font-size: 14px;
            margin-left: 10px;
          }
        }
      }
    }
    .address_list {
      .address_item {
        font-size: 14px;
        border: 1px solid #dcdcdc;
        color: #6e6e6e;
        padding: 10px 10px;
        margin-bottom: 20px;
        cursor: pointer;
        .radio {
          margin-right: 14px;
          .iconfont {
            font-size: 22px;
            color: #a5a5a5;
            &.icon-danxuanyixuan1 {
              color: #f62560;
            }
          }
        }
        p {
          height: 22px;
          line-height: 22px;
        }
      }
    }
    &.custom_dialog_address {
      .diaog_head {
        height: 60px;
      }
      .diaog_body {
        height: calc(68vh - 180px);
      }
    }
    .dialog_footer {
      .link {
        a {
          font-size: 16px;
          color: #fe3c46;
        }
      }
    }
  }
  .custom_dialog_attr {
    .diaog_head {
      height: 40px;
      .close_icon {
        top: 8px;
      }
    }
    .diaog_body {
      margin: 15px 0;
      height: calc(68vh - 255px);
      .shop_attr_column {
        margin-bottom: 30px;
        .title {
          font-size: 14px;
          color: #3c3c3c;
          position: relative;
          padding-left: 10px;
          margin-bottom: 15px;
          &::before {
            position: absolute;
            width: 3px;
            height: 15px;
            top: 50%;
            transform: translateY(-50%);
            background: #ff0042;
            display: inline-block;
            content: "";
            left: -2px;
          }
        }
        .select_list {
          flex-wrap: wrap;
          .select_item {
            padding: 0 15px 0 17px;
            background: #f5f5f5;
            border-radius: 15px;
            font-size: 12px;
            color: #3c3c3c;
            margin: 0 10px 10px 0;
            position: relative;
            min-width: 125px;
            min-height: 45px;
            border: 2px solid #f5f5f5;
            box-sizing: border-box;
            cursor: pointer;
            height: 30px;
            &.active {
              background: #fff;
              border: 2px solid #f5f5f5;
              box-sizing: border-box;
            }
            .icon-3tuihuanhuozhengcegouxuan {
              font-size: 24px;
              color: #ff0042;
            }
          }
        }
      }
    }
    .dialog_footer {
      height: 185px;
      .step_wrap {
        padding: 0 20px;
        /deep/ .el-input-number {
          width: 50%;
          flex-shrink: 0;
        }
      }
      .price_group {
        padding: 0 20px;
        margin: 20px 0;
        .price_item {
          font-size: 14px;
          color: #3c3c3c;
          margin-bottom: 10px;
          &:last-child {
            margin-bottom: 0;
          }
          .price {
            font-size: 16px;
          }
          span {
            font-size: 12px;
            margin-right: 10px;
            &.red {
              color: #c63621;
              margin-right: 5px;
            }
          }
          .input_box {
            flex: 1;
          }
        }
      }
    }
  }
}
</style>